export enum CmsAuthorizationEnum {
  None = 0,
  Admin = 1,
  Editor = 2,
  Contributor = 3
}
